import React from 'react';
import { Image } from 'antd';
import { attachmentSrc, SupportAttachment } from '../../services/supportApi';
import { formatBytes } from './format';
import * as S from './styles';

/**
 * Images open in antd's lightbox; videos play inline (the BE streams with Range support so
 * seeking works). Both use the signed URL from the message payload.
 */
const AttachmentView: React.FC<{ attachments: SupportAttachment[] }> = ({ attachments }) => {
  if (attachments.length === 0) return null;
  const images = attachments.filter((a) => a.kind === 'IMAGE');
  const videos = attachments.filter((a) => a.kind === 'VIDEO');
  return (
    <S.AttachmentGrid>
      {images.length > 0 && (
        <Image.PreviewGroup>
          {images.map((a) => (
            <div key={a.id}>
              <S.Thumb>
                <Image
                  src={attachmentSrc(a.url)}
                  alt={a.fileName}
                  width={132}
                  height={96}
                  style={{ objectFit: 'cover' }}
                  preview={{ mask: 'View' }}
                />
              </S.Thumb>
              <S.FileCaption title={a.fileName}>
                {a.fileName} · {formatBytes(a.size)}
              </S.FileCaption>
            </div>
          ))}
        </Image.PreviewGroup>
      )}
      {videos.map((a) => (
        <div key={a.id}>
          <S.VideoBox>
            <video controls preload="metadata" src={attachmentSrc(a.url)}>
              <track kind="captions" />
            </video>
          </S.VideoBox>
          <S.FileCaption title={a.fileName}>
            {a.fileName} · {formatBytes(a.size)}
          </S.FileCaption>
        </div>
      ))}
    </S.AttachmentGrid>
  );
};

export default AttachmentView;
